import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettlementsService } from 'src/app/services/settlements.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { TenantFiscal } from 'src/app/models/tenant-fiscal.model';
import { Unit } from 'src/app/models/unit.model';
import { Tenant } from 'src/app/models/tenant.model';
import { take } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-tenant-profile',
  template: `
  <div class="d-flex flex-column">
    <div class="row mt-4">
      <div class="col-12 col-sm-5 col-md-5">
        <h1 class="mb-0">Perfil</h1>
      </div>
      <div class="col-md-7 mt-4 text-end">
        <!-- button class="btn btn-primary btn-lg rounded-5" routerLink="/services/service">Agregar usuario</!-->
      </div>
    </div>
  </div>
  <div class="d-flex">
    <div class="me-3 d-none d-md-block" *ngIf="authService.hasPermission('can_create_settlements')">
      <ul #subnav app-nav-settlements [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
    </div>

    <div class="flex-fill me-3 mb-5"> <!-- style="width: 300px !important; min-width: 300px !important;" -->
      <div class="list-group rounded-4 rounded-md-5 mb-5"> 
        <div class="list-group-item py-3">
          <div class="d-flex" *ngIf="authService.hasPermission('can_read_thsm')">
            <div class="flex-fill">
              <h5 class="mt-2 mb-2" style="font-size: 15px !important; font-weight: 800;">Conexión THSM</h5>
              <table class="table table-sm">
                <tr>
                  <td class="align-middle text-center bg-zazz rounded-top-left-3 text-light" style="font-size: 11px !important;">SOCIO</td>
                  <td class="align-middle text-center bg-zazz text-light" style="font-size: 11px !important;">NEGOCIO</td>
                  <td class="align-middle text-center bg-zazz rounded-top-right-3 text-light" style="font-size: 11px !important;">CUENTA</td>
                </tr>
                <tr>
                  <td class="align-middle text-center rounded-bottom-left-3" [ngClass]="user?.thsm_id ? 'bg-zazz-gold' : 'bg-zazz'">{{user?.thsm_id}}</td>
                  <td class="align-middle text-center" [ngClass]="user?.trade_id ? 'bg-zazz-gold' : 'bg-zazz'">{{user?.trade_id}}</td>
                  <td class="align-middle text-center rounded-bottom-right-3" [ngClass]="user?.account_number ? 'bg-zazz-gold' : 'bg-zazz'">{{user?.account_number}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="d-block d-sm-flex flex-fill">
            <div class="flex-fill">
              <form [formGroup]="userForm" (ngSubmit)="onSubmit(userForm)">
                <fieldset>
                  <h5 class="mt-2 mb-4" style="font-size: 15px !important; font-weight: 800;">Datos personales</h5>
                  <div class="avatar-container text-center" style="left: 22%;">
                    <div class="image-container">
                      <img [src]="avatarURL" width="100%" height="100%">
                    </div> 
                    <label for="avatar-input-file">
                      <div class="icon-wrapper">
                        <input type="file" id="avatar-input-file" (change)="loadAvatar($event)" accept="image/*"/>
                        <fa-icon [icon]="icons.faEdit" class="text-white"></fa-icon>
                      </div>
                    </label>
                  </div>
                  <div class="form-group required mt-3">
                    <label for="name" class="form-label text-sm">Nombre(s)</label>
                    <input type="text" formControlName="name" class="form-control rounded-3" id="name" placeholder="Nombre">
                    <div *ngIf="tenantForm['name'].touched && tenantForm['name'].invalid">
                      <div *ngIf="tenantForm['name'].errors?.['required']" class="text-danger text-sm">El nombre es requerido.</div>
                    </div>
                  </div>  
                  <div class="form-group mt-2">
                    <label for="last_name" class="form-label text-sm">Primer Apellido</label>
                    <input type="text" formControlName="last_name" class="form-control rounded-3" id="last_name">
                    <div *ngIf="tenantForm['last_name'].touched && tenantForm['last_name'].invalid">
                      <div *ngIf="tenantForm['last_name'].errors?.['required']" class="text-danger text-sm">Los apellidos es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group mt-2">
                    <label for="last_name_m" class="form-label text-sm">Segundo Apellido</label>
                    <input type="text" formControlName="last_name_m" class="form-control rounded-3" id="last_name_m">
                    <div *ngIf="tenantForm['last_name_m'].touched && tenantForm['last_name_m'].invalid">
                      <div *ngIf="tenantForm['last_name_m'].errors?.['required']" class="text-danger text-sm">Los apellidos es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group mt-2">
                    <label for="dob" class="form-label text-sm">Fecha de nacimiento</label>
                    <input type="date" formControlName="dob" class="form-control rounded-3" id="dob">
                    <div *ngIf="tenantForm['dob'].touched && tenantForm['dob'].invalid">
                      <div *ngIf="tenantForm['dob'].errors?.['required']" class="text-danger text-sm">La fecha de nacimiento es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group required mt-2">
                    <label for="emailInput" class="form-label text-sm">Correo electrónico</label>
                    <input type="email" formControlName="email" class="form-control rounded-3" id="emailInput">
                    <div *ngIf="tenantForm['email'].touched && tenantForm['email'].invalid">
                      <div *ngIf="tenantForm['email'].errors?.['required']" class="text-danger text-sm">El correo es requerido.</div>
                      <div *ngIf="tenantForm['email'].errors?.['email']" class="text-danger text-sm">El correo no es válido.</div>
                    </div>
                  </div>  
                  <div class="form-group required mt-2">
                    <label for="phone" class="form-label text-sm">Teléfono</label>
                    <input type="tel" formControlName="phone" class="form-control rounded-3" id="phone" maxlength="10">
                    <div *ngIf="tenantForm['phone'].touched && tenantForm['phone'].invalid">
                      <div *ngIf="tenantForm['phone'].errors?.['required']" class="text-danger text-sm">El teléfono es requerido.</div>
                      <div *ngIf="tenantForm['phone'].errors?.['minlength']" class="text-danger text-sm">El teléfono no es válido (10 dígitos).</div>
                    </div>
                  </div>
                </fieldset>                
                <div class="form-group mt-3 text-end">
                  <button class="btn btn-zazz-dark" [disabled]="loading" *ngIf="authService.hasPermission('can_edit_tenants')">
                    <fa-icon [icon]="icons.faSave" class="me-2" *ngIf="!loading"></fa-icon>
                    <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="me-2" *ngIf="loading"></fa-icon>
                    Actualizar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
      
    <div class="flex-fill">
      <div class="list-group rounded-4 rounded-md-5">
        
        <div class="list-group-item py-3 p-sm-4">

          <ul ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="false" class="nav-tabs">
            <li [ngbNavItem]="1" [destroyOnHide]="true" >
              <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Contraseña</button>
              <ng-template ngbNavContent>
                <app-form-user-password
                  [user]="user" 
                ></app-form-user-password>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" [destroyOnHide]="true" >
              <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Ubicaciones</button>
              <ng-template ngbNavContent>
                <app-tenant-units
                  [user]="user"
                  [units]="units"
                  (updateData)="loadTenant($event)"
                ></app-tenant-units>
              </ng-template>
            </li>
            <li [ngbNavItem]="3" [destroyOnHide]="true">
              <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Datos físcales</button>
              <ng-template ngbNavContent>
                <app-form-tenant-fiscal
                  [tenant]="user" 
                  [catalogs]="catalogs"
                  (save)="updateFiscal($event)"
                ></app-form-tenant-fiscal>
              </ng-template>
            </li>
            <li [ngbNavItem]="4" [destroyOnHide]="true"  >
              <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Registro público</button>
              <ng-template ngbNavContent>
                <app-form-public-record 
                  [publicRecord]="publicRecord" 
                  (publicRecordData)="createPublicRecord($event)"
                ></app-form-public-record>
              </ng-template>
            </li>
            <li [ngbNavItem]="5" [destroyOnHide]="true" *ngIf="authService.hasPermission('can_read_public_record')">
              <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Representante legal</button>
              <ng-template ngbNavContent>
                <!-- app-form-public-record 
                  [publicRecord]="legal_rep" 
                  [isLegal]="true"
                  [related]="public_record?.id" 
                  (publicRecordData)="createLegalRep($event)"
                ></app-form-public-record -->
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav"></div>          
        </div>
      </div>
    </div>
  </div>
  `,
  styleUrls: []
})
export class TenantProfileComponent implements OnInit {
  @ViewChild('tabs') tabs!: ElementRef | undefined;
  @ViewChild('tabContent') tabContent!: ElementRef | undefined;
  
  user: Tenant | null = null;
  avatarURL: any = '';
  userId: number = 0;
  loading: boolean = false;

  active = 3;

  userForm: FormGroup = new FormGroup({});
  addressData: any = null;
  fiscalData: TenantFiscal | null = null;
  publicRecord: any = null;
  public_record: any = null;
  legal_rep: any = null;

  apiUrl: string = environment.AWS_REST_WSPREFIX;

  passwordPattern = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@#!%*?&])[A-Za-z\d$@$!%*?&].{8,}';

  imageError: string = "";
  isImageSaved: boolean = false;
  cardImageBase64: string = "";
  previewImagePath: string = "";

  units: Unit[] = [];

  currentView: string = 'tenants';

  constructor(
    private store: SettlementsService,
    private activateRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public catalogs: CatalogsService,
    public icons: IconsService,
    public images: ImageService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.buildForm();

    this.activateRoute.params.subscribe(params => {
      this.userId = params['id'];
      this.loadTenant(params['id']);
    });
  }

  buildForm() {
    this.userForm = this.fb.group({
      id: [''],
      email: ['', Validators.required],
      name: ['', Validators.required],
      last_name: [''],
      last_name_m: [''],
      phone: ['', Validators.required],
      dob: [''],
    });
  }

  get tenantForm() {
    return this.userForm.controls;
  }

  async loadTenant(id: any) {
    this.loading = true;
    this.store.getTenant(id)
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
        console.log('loadTenant data => ', data);
        this.user = data;
        this.userForm.patchValue(data);

        if (data.avatar) {
          this.avatarURL = this.images.buildURL(data.avatar);
        }

        if (data.public_record_id) {
          this.store.getPublicRecord(data.public_record_id).subscribe((publicRecord: any) => {
            this.publicRecord = publicRecord;
          });
        }

        this.loading = false;
      }, error: (err: any) => {
        console.error(err);
        this.toastr.error('Ocurrió un error al cargar el perfil.');
        this.loading = false;
      }
    });

    this.loadUnits(id);
  }

  loadUser(id: number) {
    this.store.getTenant(this.userId).subscribe((data: any) => {
      console.log('loadUser data => ', data);
      let el = data.avatar;

      this.avatarURL = `${this.apiUrl}/storage/${el.blob.key.substring(0,2)}/${el.blob.key.substring(2,4)}/${el.blob.key}`;
      console.log("avatarURL => ", this.avatarURL);
    });
  }

  loadUnits(id: number) {
    this.units = [];
    this.store.getTenantUnits(this.userId).subscribe((data: any) => {
      console.log('loadUnits => ', data);
      this.units = data;
    });
  }

  loadAvatar(event: any): void {

    this.imageError = "";

    if (event.target.files && event.target.files[0]) {
      // Size Filter Bytes
      const max_size = 20971520;
      const allowed_types = ['image/png', 'image/jpeg'];
      const max_height = 15200;
      const max_width = 25600;

      if (event.target.files[0].size > max_size) {
        this.imageError = 'Maximum size allowed is ' + max_size / 1000 + 'Mb';

        // return false;
      }

      // if (!_.includes(allowed_types, event.target.files[0].type)) {
        // this.imageError = 'Only Images are allowed ( JPG | PNG )';
        // return false;
      // }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = (rs: any): void => {
          const img_height = rs.currentTarget['height'];
          const img_width = rs.currentTarget['width'];
          // console.log(img_height, img_width);
          if (img_height > max_height && img_width > max_width) {
            this.imageError = 'Maximum dimentions allowed ' + max_height + '*' + max_width + 'px';
            // return false;
          } else {
            const imgBase64Path = e.target.result;
            this.cardImageBase64 = imgBase64Path;
            this.isImageSaved = true;
            this.previewImagePath = imgBase64Path;
            console.log('imgBase64Path => ', imgBase64Path);
            console.log('previewImagePath => ', this.previewImagePath);
            let payload = {
              id: this.userId,
              data: this.previewImagePath
            }
            console.log('event => ', event.target.files[0]);
            this.store.updateTenantAvatar(this.userForm.value.id, payload).subscribe({
              next: (data: any) => {
                this.toastr.success('Avatar actualizado correctamente.');
                this.loadUser(this.userId);
              },
              error: (err: any) => {
                console.log(err);
                this.toastr.error('Ocurrió un error al actualizar el avatar.');
              }
            });
          }
        };
      };

      reader.readAsDataURL(event.target.files[0]);
    }    
  }

  onSubmit(form: any) {
    this.loading = true;

    const profile = {
      id: this.userId,
      name: form.value.name,
      last_name: form.value.last_name,
      last_name_m: form.value.last_name_m,
      phone: form.value.phone,
      email: form.value.email,
      dob: form.value.dob
    };
    const profile_address = {
      id: this.addressData ? this.addressData.id : null,
      country: 'MX',
      address: form.value.street,
      state: form.value.state,
      city: form.value.city,
      zip_code: form.value.zip,
      tenant_id: this.userId
    };

    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched();
      this.toastr.error('No está completa la información.', 'Error');
      this.loading = false;
      return;
    }

    console.log('profile => ', profile);

    this.store.updateTenant(this.userId, profile).subscribe((data: any) => {
      this.loadTenant(this.userId);
      this.toastr.success('Perfil actualizado correctamente.');
      /*if (this.addressData == null) {
        this.store.createTenantAddress(profile_address).subscribe((data: any) => {
          console.log('data => ', data);
          // this.route.navigate(['/tenant']);
          this.toastr.success('Perfil actualizado correctamente.');
        });
      } else {
        this.store.updateTenantAddress(profile_address.id, profile_address).subscribe((data: any) => {
          console.log('data => ', data);
          this.toastr.success('Perfil actualizado correctamente.');
        });
      }*/
    });
  }

  saveAddress(event: any) {
    console.log("saveAddress => ", event);
    
    if (event.id != '') {
      this.store.updateTenantAddress(event.id, event).subscribe({
        next: (data: any) => {
          this.toastr.success('Dirección actualizada correctamente.', 'Éxito');
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Error al actualizar la dirección.', 'Error');
        }
      });
    } else {
      console.log('createTenantAddress => ', event);
      this.store.createTenantAddress(event).subscribe({
        next: (data: any) => {
          this.toastr.success('Dirección actualizada correctamente.', 'Éxito');
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Error al actualizar la dirección.', 'Error');
        }
      });
    }
  }

  updateFiscal(event: any) {
    console.log('updateFiscal => ', event);
    event.tenant_id = this.user!.id;
    if (!event.id) {
      this.store.createTenantFiscal(event).subscribe({
        next: (data: any) => {
          this.toastr.success('Datos fiscales actualizados correctamente.', 'Éxito');
        },
        error: (err: any) => {
          this.toastr.error('Error al actualizar los datos fiscales.', 'Error');
        }
      });
    } else {
      this.store.updateTenantFiscal(event.id, event).subscribe({
        next: (data: any) => {
          this.toastr.success('Datos fiscales actualizados correctamente.', 'Éxito');
        },
        error: (err: any) => {
          this.toastr.error('Error al actualizar los datos fiscales.', 'Error');
        }
      });
    }
  }

  createPublicRecord(event: any) {
    console.log("create ", event);

    const payload: any = event;
    payload.profile_id = this.user!.id;

    if (event.id) {
      this.store.updatePublicRecord(event.id, event).subscribe({
        next: (res: any) => {
          console.log('updatePublicRecord res', res);
          this.toastr.success('El registro público se actualizó correctamente.', 'Actualizado');
          this.store.updateTenant(this.userId, { public_record_id: res.id }).subscribe((data: any) => {
          // this.router.navigate(['/perfiles']);
          });
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al actualizar el registro público.', 'Error');
        }
      });
    } else {
      this.store.createPublicRecord(event).subscribe({
        next: (res: any) => {
          console.log('createPublicRecord res', res);
          this.toastr.success('El registro público se creó correctamente.', 'Creado');
          this.store.updateTenant(this.userId, { public_record_id: res.id }).subscribe((data: any) => {
            // this.router.navigate(['/perfiles']);
          });
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al crear el registro público.', 'Error');
        }
      });
    }
  }

  createLegalRep(event: any) {
    const payload: any = event;
    payload.profile_id = this.user!.id;

    if (event.id) {
      this.store.updatePublicRecord(event.id, event).subscribe({
        next: (res: any) => {
          console.log('updatePublicRecord res', res);
          this.toastr.success('El registro público se actualizó correctamente.', 'Actualizado');
          // this.store.updateProfile(this.profile.id, { public_record_id: res.id }).subscribe((data: any) => {
          // this.router.navigate(['/perfiles']);
          // });
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al actualizar el registro público.', 'Error');
        }
      });
    } else {
      this.store.createPublicRecord(event).subscribe({
        next: (res: any) => {
          console.log('createPublicRecord res', res);
          this.toastr.success('El registro público se creó correctamente.', 'Creado');
          // this.store.updateProfile(this.profile.id, { public_record_id: res.id }).subscribe((data: any) => {
            // this.router.navigate(['/perfiles']);
          // });
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al crear el registro público.', 'Error');
        }
      });
    }
  }
}
